import { useState } from "react";


function BlogFAQ({defaultAccordion}) {
    const [activeDefault, setActiveDefault] = useState(0);
  return (
    <>
        <div
            className="dlab-accordion"
            id="accordionFaq"
            defaultactivekey="0"
        >
            {defaultAccordion.map((d, i) => (
                <div className="card" key={i}>
                    <div
                        eventkey={`${i}`}
                        className="card-header"
                        onClick={() =>
                            setActiveDefault(activeDefault === i ? -1 : i)
                        }
                    >
                        <h2 className="h5 dlab-title">
                            <a 
                                className={`${
                                    activeDefault === i ? "" : "collapsed"
                                }`}
                                onClick={() =>
                                    setActiveDefault(
                                        activeDefault === i ? -1 : i
                                    )
                                }
                                title={d.Question}
                                href="javascript:void(0);"
                            >
                                {" "}
                                {d.Question}
                            </a>
                        </h2>
                    </div>
                    <div className={`${
							activeDefault === i ? "collapsed show" : "collapsed"
						}`} eventkey={`${i}`} onClick={() =>
							setActiveDefault(
								activeDefault === i ? -1 : i
							)
						}
					>
                        <div className="card-body" id={`answer${i}`}>
                            <p className="m-b0" dangerouslySetInnerHTML={{__html: d.Answer}} ></p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </>
  )
}

export default BlogFAQ;